import { render, staticRenderFns } from "./AccessibilityReportKeusote.vue?vue&type=template&id=f219c664&scoped=true"
import script from "./AccessibilityReportKeusote.vue?vue&type=script&lang=ts"
export * from "./AccessibilityReportKeusote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f219c664",
  null
  
)

export default component.exports